import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, Button } from "@mui/material";
import { Drivers, Hosts } from "../const/index";
import Slider from "react-slick";
import "./AsNavFor.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Section4() {
  const [activeCat, setActiveCat] = useState("Drivers");
  const [data, setData] = useState(Drivers);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    pauseOnHover: false,


    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 1500,

    beforeChange: (_, next) => {
      setCurrentSlide(next);
    },
  };

  const settings2 = {
    dots: false,
    infinite: true, // If needed, set this to false to prevent infinite scrolling
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 1500,
    beforeChange: (_, next) => {
      setCurrentSlide(next);
    },
  };

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);

  const handleCat = (cat) => {
    setActiveCat(cat);
    console.log(activeCat);
    setData(cat === "Drivers" ? Drivers : Hosts);
  };

  return (
    <Box
      sx={{
        overflow: "hidden",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0e0e0e",
      }}
      id="faq"
    >
      <Box
        sx={{
          maxWidth: '150rem',
          p: {
            xs: '1rem', md: '10rem',
          },
          m: 'auto'
        }}
      >

        <Typography
          sx={{
            color: "white",
            width: "fit-content",
            margin: 'auto',
            mb: { xs: "1rem", sm: "4rem" },
            fontSize: {
              xs: "3rem",
              sm: '4rem',
              md: "4rem",
            },
            fontWeight: 800,
          }}
        >
          How it Works
        </Typography>


        {/* slider */}
        <Box
          sx={{
            m: "auto",
            maxWidth: '450rem',
            p: { md: "4rem 2rem", xs: "1rem 1rem" }
          }}
        >

          <Box
            sx={{
              display: "flex",
              alignItems: "left",
              justifyContent: "left",
              height: 'fit-content',
              mb: { xs: "2rem", md: '4rem' },
            }}
          >
            <Button
              onClick={() => handleCat("Drivers")}
              sx={{
                color: "#fff",
                fontFamily: "mulish",

                fontWeight: 700,
                fontSize: {
                  xs: "2rem",
                  md: "2.5rem",
                  lg: "3rem",
                },
                width: "181px",
                height: "45px",
                opacity: activeCat === "Drivers" ? 1 : 0.5, // Reduce opacity for active category
                textTransform: 'none',
                borderRadius: '150px'
              }}
            >
              Drivers
            </Button>

            <Button
              onClick={() => handleCat("Hosts")}
              sx={{
                color: "#fff",
                fontFamily: "mulish",
                fontSize: {
                  xs: "2rem",
                  md: "2.5rem",
                  lg: "3rem", // Font size for medium screens and above (desktop)
                },
                fontWeight: 700,
                width: "181px",
                height: "45px",
                opacity: activeCat === "Hosts" ? 1 : 0.5,
                textTransform: 'none',
                borderRadius: '150px'
              }}
            >
              Hosts
            </Button>
          </Box>


          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: { xs: "column", md: "row" },
              background: "#0C0C0C",
              borderRadius: '15px',
              p: "4.5rem 1rem",
              justifyItems: 'center',
              alignItems: 'center',
              gap: '6rem'
            }}
          >
            <Box
              sx={{
                textAlign: { xs: "center", md: "center", lg: "left" },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: { xs: "100%", sm: "58%" },
              }}
            >
              <div className="slider-container">
                <Slider {...settings}>
                  {data.map((item, index) => (
                    <Box key={item.id} sx={{
                      color: "white",
                      display: "flex",
                      gap: '2.5rem',
                      mb: '1.2rem',
                      height: "12rem",
                      opacity: index === currentSlide ? 1 : 0.4,
                      transition: "opacity 0.4s ease",
                    }}>
                      <Typography
                        sx={{
                          color: "white",
                          fontSize: { xs: "2rem", md: "2.4rem" },
                          fontWeight: 700,
                          textAlign: 'left',
                          mb: '0.8rem'
                        }}
                      >
                        {item.detail1}
                      </Typography>

                      <Typography
                        sx={{
                          color: "white",
                          fontSize: '1.4rem',
                          fontWeight: 700,
                          maxWidth: '34ch',
                          textAlign: 'left',
                        }}
                      >
                        {item.detail2}
                      </Typography>
                    </Box>
                  ))}
                </Slider>
              </div>
            </Box>

            <Box
              sx={{
                width: { xs: "100%", sm: "40%" }, // Full width on small screens, fixed on medium and large
                m: 'auto',
              }}
            >

              <Slider
                {...settings2}
                slidesToShow={1} // Display one image at a time
                slidesToScroll={1} // Scroll one image at a time
              >
                {data.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      // display: "flex",
                      // alignSelf: "center",
                      // justifyContent: "center",
                      // alignItems: "center",
                    }}
                  >
                    <Box
                      component="img"
                      src={item.image}
                      alt={`Driver ${item.number}`}
                      sx={{
                        objectFit: "cover", // Ensures the image maintains aspect ratio
                        display: "block", // Makes sure no flexbox is applied to the image itself
                        maxWidth: "100%", // Ensures the image won't overflow the container
                        maxHeight: "100%", // Ensures the image is within the container
                        margin: "0 auto", // Centers the image horizontally
                      }}
                    />
                  </div>
                ))}
              </Slider>
            </Box>

          </Box>
        </Box>
      </Box>
    </Box >
  );
}

export default Section4;